import { useMemo } from 'react';

import { MenuItem } from '@mui/material';

import { useStoreLocations } from 'src/providers/StoreLocationsProvider';

import { Field } from '.';

export function SingleLocationField({
  name,
  label = 'Location',
}: {
  name: string;
  label?: string;
}) {
  const { data: storeLocations, loading: storeLocationsLoading } = useStoreLocations();

  const storeLocationsOptions = useMemo(() => {
    if (storeLocationsLoading) {
      return [];
    }

    return storeLocations.map((location) => ({
      label: location.name,
      value: location.id,
    }));
  }, [storeLocations, storeLocationsLoading]);

  return (
    <Field.Select name={name} label={label}>
      {storeLocationsOptions.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </Field.Select>
  );
}
